"use client";

import { useState } from "react";
import { DataTable } from "../DataTable/DataTable";
import { AppShell } from "../AppShell/AppShell";
import { ToastProvider, useToast } from "../components/Toast";
import { buildDemoColumns, demoFaqRows, demoNav, type DemoFaqRow } from "./fixtures";

/**
 * 「一頁 demo route」——模擬 admin/faq 清單頁：AppShell + DataTable 組裝在一起。
 * 只用假資料，不接真 API，供本套件的 vitest 基本渲染測試使用，
 * 也可直接被 web/admin 的頁面複製當作接線範本。
 */
function DataTableDemoInner() {
  const toast = useToast();
  const [selected, setSelected] = useState<Array<string | number>>([]);

  const columns = buildDemoColumns(
    (row: DemoFaqRow) => toast.show(`編輯：${row.faqName}`, { variant: "info" }),
    (row: DemoFaqRow) => toast.show(`刪除：${row.faqName}`, { variant: "danger" }),
  );

  return (
    <AppShell nav={demoNav} activeHref="/admin/faq" brand="心成後台" title="常見問答" user={{ name: "測試管理員" }}>
      <DataTable<DemoFaqRow>
        columns={columns}
        rows={demoFaqRows}
        rowKey={(row) => row.id}
        variant="admin"
        storageKey="demo-faq"
        selectedKeys={selected}
        onSelectionChange={setSelected}
        exportFileName="faq"
      />
    </AppShell>
  );
}

export function DataTableDemo() {
  return (
    <ToastProvider>
      <DataTableDemoInner />
    </ToastProvider>
  );
}
